// extracted by mini-css-extract-plugin
export default {"table":"lessonTable_table__slF01"};